import { jsonProperty, Serializable } from 'ts-serializable';

export class RefreshTokenDto extends Serializable {
  @jsonProperty(String, null) accessToken: string | null = null;
  @jsonProperty(String, null) refreshToken: string | null = null;
}
